import React, { useState } from 'react';
import { Button, Space, Typography, Modal } from 'antd';
import { ThunderboltOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import ShelfAutocomplete from './ShelfAutocomplete';
import { useReceiptPutaway } from '@contexts/operator/ReceiptPutawayContext';

const { Text } = Typography;

export default function BatchApplyBar() {
  const { t } = useTranslation();
  const { state, actions } = useReceiptPutaway();
  const [draft, setDraft] = useState({ shelfId: null, location: '' });

  if (state.selection.size === 0) return null;

  // 是否有任一已選 item 已經有手動配置（多列、或單列已填數量但 shelf 不同）；
  // 套用會把整列覆蓋成「remaining 全部到新 shelf」，這對手動分箱的 operator 是破壞性操作。
  const hasExistingAllocations = () => {
    return Array.from(state.selection).some(itemId => {
      const rows = state.rowStates[itemId] || [];
      if (rows.length > 1) return true;
      const r = rows[0];
      return r && (r.shelfId || (r.location && r.location !== ''));
    });
  };

  const performApply = () => {
    actions.batchApplyShelf({ shelfId: draft.shelfId, location: draft.location });
    actions.clearSelection();
    setDraft({ shelfId: null, location: '' });
  };

  const handleApply = () => {
    if (!draft.location) return;
    if (hasExistingAllocations()) {
      Modal.confirm({
        title: t('operator.pages.putaway.batch_apply.overwrite_title', {
          defaultValue: '套用會覆蓋既有分配',
        }),
        content: t('operator.pages.putaway.batch_apply.overwrite_body', {
          defaultValue: '已選的品項中有人工配好的儲位／數量。套用後會清除原本的分配，整批改為新的儲位。確定繼續？',
        }),
        okText: t('common.button.confirm'),
        cancelText: t('common.button.cancel'),
        onOk: performApply,
      });
    } else {
      performApply();
    }
  };

  return (
    <div style={{
      position: 'sticky',
      top: 0,
      zIndex: 10,
      background: 'linear-gradient(90deg, #fffbe6 0%, #fff7db 100%)',
      borderBottom: '1px solid #ffe58f',
      padding: '10px 24px',
      display: 'flex',
      alignItems: 'center',
    }}>
      <Space size={12}>
        <ThunderboltOutlined style={{ color: '#d48806', fontSize: 16 }} />
        <Text strong style={{ color: '#874d00' }}>
          {t('operator.pages.putaway.batch_apply.selected', { count: state.selection.size })}
        </Text>
        <Text type="secondary" style={{ fontSize: 13 }}>
          {t('operator.pages.putaway.batch_apply.label')}
        </Text>
        <ShelfAutocomplete
          value={draft.location}
          warehouseId={state.receipt?.warehouse?.id}
          onChange={setDraft}
        />
        <Button type="primary" disabled={!draft.location} onClick={handleApply}>
          {t('operator.pages.putaway.batch_apply.apply')}
        </Button>
        <Button size="small" type="text" onClick={actions.clearSelection}>
          {t('operator.pages.putaway.batch_apply.clear')}
        </Button>
      </Space>
    </div>
  );
}
